import api from '@/utils/httpClient';
import { ApiListResponse, ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';
import { DiseaseDto, DiseaseForCreateDto } from '../dtos/Event';

export interface CreateDiseaseForEventParameters {
	eventId: string;
	data: DiseaseForCreateDto;
}

const eventKeys = {
  detail: (id: string) => ['event', id],
  disease: (id: string) => ['event', id, 'disease'],
  inputRequests: (id: string) => ['event', id, 'inputrequests'],
  legacyCaseHistoryId: (eventId: string, patientId: string) => [
    'legacyCaseHistoryId',
    'event',
    eventId,
    'patient',
    patientId
  ]
};

export { eventKeys };

export async function createDiseaseForEvent(eventId: string, data: DiseaseForCreateDto) {
  const config: any = { containsPHI: false };
  return api
    .post(`/api/events/${eventId}/diseases`, data, config)
    .then((response) => (response.data as ApiResponse<DiseaseDto>).data);
}

async function getDiseasesForEvent(id: string) {
  const config: any = { containsPHI: false };
  return api.get(`/api/events/${id}/diseases`, config).then((response) => {
    const responseData = response.data as ApiListResponse<DiseaseDto>;

    return responseData.data;
  });
}

export function useCreateDiseaseForEvent(
  options?: UseMutationOptions<DiseaseDto, AxiosError, CreateDiseaseForEventParameters>
) {
  return useMutation(
    async ({ eventId, data }: CreateDiseaseForEventParameters) =>
      createDiseaseForEvent(eventId, data),
    options
  );
}

export function useDiseaseForEvent(id: string, options?: UseQueryOptions<DiseaseDto[]>) {
  return useQuery(eventKeys.disease(id), async () => getDiseasesForEvent(id), options);
}
